export default __webpack_public_path__ + "static/media/linkedin.4804b54b.svg";